import { observer } from 'mobx-react-lite';
import { IReconciliation } from '@/fsd/entities/mutualSettlements';
import MutualSettlementsBodyLine from './MutualSettlementsBodyLine/MutualSettlementsBodyLine';

interface Props {
  state: IReconciliation[];
}

const MutualSettlementsBody = observer(({ state }: Props) => {
  return (
    <>
      {state.map((reconciliation) => (
        <MutualSettlementsBodyLine
          key={reconciliation.id}
          reconciliation={reconciliation}
        />
      ))}
    </>
  );
});

export default MutualSettlementsBody;
